import AppRoute from "models/AppRoute"

const StocktakingsRoute = new AppRoute({
    route: "/stocktakings",
    navbar: true,
    authRequired: true,
})

export default StocktakingsRoute
